import { useEffect, useRef } from 'react';

function usePrevious(value) {
  const ref = useRef(); // Create a ref to store the previous value

  useEffect(() => {
    // This effect runs *after* every render
    // Update the ref's current property to the current 'value'
    ref.current = value;
  }, [value]); // Re-run the effect only when 'value' changes

  // Return the value that was stored in the ref *before* the current render
  return ref.current;
}

export default usePrevious;